import { ModuleIOValueTypeEnum, ModuleInputKeyEnum, ModuleTemplateTypeEnum } from '../../constants';
import { FlowNodeInputTypeEnum, FlowNodeTypeEnum } from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';

export const GlobalVariableModule: FlowModuleTemplateType = {
  id: 'globalVariable',
  templateType: ModuleTemplateTypeEnum.getContent,
  flowType: FlowNodeTypeEnum.globalVariable,
  name: '全局变量',
  description: '设置一个在全流程中保持一致的全局变量',
  inputs: [
    {
      label: '添加全局变量',
      valueType: ModuleIOValueTypeEnum.string,
      type: FlowNodeInputTypeEnum.addInputParam,
      key: ModuleInputKeyEnum.addTemplate,
      edit: false,
      editField: {
        dataType: true,
        description: true,
        key: true,
        name: false,
        required: true,
      },
      defaultEditFieldValue: {
        valueType: 'string',
        required: true,
      },
      showTargetInApp: false,
      showTargetInPlugin: false,
    },
  ],
  outputs: [],
};
